import { alpha, Card, styled } from '@mui/material';

export const PageContentCard = styled(Card)({
  boxSizing: 'border-box',
  width: 'auto',
  marginTop: '16px',
  padding: '16px',
  borderRadius: '5px',
  boxShadow: [
    `-2px 0 4px ${alpha('#011008', 0.08)}`,
    `2px 0 4px ${alpha('#011008', 0.08)}`,
    `0 4px 4px ${alpha('#011008', 0.1)}`,
  ].join(', '),

  '& hr': {
    backgroundColor: '#E2E2E2',
  },

  '&.RaEdit-card, &.RaCreate-card': {
    marginTop: 0,
  },

  '& > form > .MuiCardContent-root': {
    padding: 0,
  },

  '& > form > .MuiToolbar-root': {
    padding: '0 !important',
  },
});
